import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 40px;
  display: flex;
  padding: 0 4px 0 20px;
  text-align: left;
  align-items: center;
  border-bottom: 1px solid var(--v3-black-4);
  background: var(--v3-black-0);
  &:last-child {
    border-bottom: none;
  }
`;

export const Name = styled.div<{ padding?: boolean }>`
  flex: 1;
  line-height: 1;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.48px;
  color: var(--v3-text-color);
  ${props =>
    props.padding &&
    ` padding-left: 8px;
    `}
`;

export const SpinWrapper = styled.div`
  padding: 24px;
  text-align: center;
`;
